import React from "react";
import AsyncSelect from "react-select/async";
import { ApiResponse } from "Types/OSM/Response";

export type PejabatOption = {
  value: number | string;
  label: string;
  nama?: string;
  jabatan?: string;
  unit_jabatan?: string;
  email?: string;
  nip?: string | number;
  groupLineId?: number | string;
  unit_id?: number | string;
};

interface PejabatMultiSelectProps {
  value: PejabatOption | PejabatOption[] | null;
  onChange: (value: PejabatOption | PejabatOption[] | null) => void;
  placeholder?: string;
  minSearchLength?: number; // optional, default 3
  isMulti?: boolean; // optional, default true
}

const PejabatMultiSelect = ({
  value,
  onChange,
  placeholder = "Ketik untuk mencari pegawai...",
  minSearchLength = 3,
  isMulti = true,
}: PejabatMultiSelectProps) => {
  const loadOptions = async (inputValue: string): Promise<PejabatOption[]> => {
    if (inputValue.length < minSearchLength) {
      return [];
    }

    // Convert to lowercase for backend search
    const searchValue = inputValue.toLowerCase();

    const res = await fetch("/api/doServices", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        method: "GET",
        endpoint: `kepegawaian/pegawai/data?page=1&limit=10&search=${encodeURIComponent(searchValue)}`,
        isForm: false,
        isImage: false,
      }),
    });

    if (!res.ok) return [];

    const result = (await res.json()) as ApiResponse;
    if (result.http_code !== 200 || !Array.isArray(result.data)) return [];

    // console.log('Pegawai data from API:', result.data);

    const opts: PejabatOption[] = result.data.map((item: any) => ({
      value: item.nip,
      label: `${item.jabatan_tambahan || item.jabatan_akhir || '-'} - ${item.unit_jabatan || item.unit_nama || '-'} - ${item.namagelar || '-'} - ${item.nip || '-'}`,
      nama: item.namagelar,
      jabatan: item.jabatan_tambahan || item.jabatan_akhir || '-',
      unit_jabatan: item.unit_jabatan || item.unit_nama || '-',
      email: item.email || item.email_kantor || "",
      unit_id: item.unit_id,
    }));

    // console.log('Mapped options:', opts);

    return opts;
  };

  return (
    <AsyncSelect
      isMulti={isMulti}
      cacheOptions
      defaultOptions={false}
      loadOptions={loadOptions}
      value={value}
      onChange={(val) => {
        // console.log('PejabatMultiSelect onChange triggered, val:', val);
        if (isMulti) {
          onChange((val || []) as PejabatOption[]);
        } else {
          onChange(val as PejabatOption);
        }
      }}
      placeholder={placeholder}
      classNamePrefix="react-select"
    />
  );
};

export default PejabatMultiSelect;